// profileExtension.ts
import { clientConnector } from '@games/socket-client'

type ProfileRequest = {
  userId: string
}

type ProfileResponse = {
  id: string
  username: string
  avatarUrl: string
}

type ProfileCallback = (error: string | null, response: ProfileResponse | null) => void

/**
 * Расширяет clientConnector для работы с профилем пользователя
 */
export function extendSocketWithUser() {
  // Регистрируем компонент для профиля с указанием имени метода для ответа
  const userComponent = {
    name: 'user',
    methods: {
      getProfile: {
        emitEvent: 'user:getProfile',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onProfileReceived' // Имя метода для получения ответа в Unity
      }
    }
  }
  
  // При регистрации компонента автоматически создается clientConnector.getProfile
  clientConnector.registerComponent(userComponent)
  
}